import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { Version5Component } from './version5.component';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
const rutas: Routes = [
  {
      path     : 'cultureAudit',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX6/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX7/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX8/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX9/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX10/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX11/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX12/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX13/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX14/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX15/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX16/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX17/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX18/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX19/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'culture_MX20/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'icca/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'Culture_Brief/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'Culture_Audit/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
  {
      path     : 'Culture_Brief_Culture_Audit/cultureAudit/:id',
      component: Version5Component,
      canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [Version5Component],
  imports: [
    CommonModule,
    MatIconModule,
    FlexLayoutModule,
    TranslateModule,
    RouterModule.forChild(rutas)
  ]
})
export class Version5Module { }
